import { TopUpForm, TopUpFormConfig } from './TopUpForm'
import {
  useGetOrgUserBalanceSummary,
  useCreateOrgUserPayment,
} from '@/services/billing'
import { User } from 'lucide-react'
import {
  UserBalanceDetailsDialog,
  OrgBalanceDetailsDialogProps,
  UserBalanceDetailsDialogProps,
} from '@/components/balance-details-dialog'

export interface UserTopUpFormProps {
  userId: number
  variant?: 'display-only' | 'full'
  onClose?: () => void
}

const userTopUpConfig: TopUpFormConfig = {
  useBalanceData: (userId?: number) => {
    // useGetOrgUserBalanceSummary requires user_id to be defined
    // If userId is undefined, we create a disabled query
    const result = useGetOrgUserBalanceSummary(userId!)
    return {
      data: result.data,
      isLoading: result.isLoading,
      isError: result.isError || !userId,
      error: result.error,
    }
  },
  useCreatePayment: useCreateOrgUserPayment,
  icon: User,
  title: 'Personal Credits',
  loadingMessage: 'Loading personal balance...',
  errorMessagePrefix: 'Failed to load personal balance',
  noDataMessage: 'No personal balance data available',
  BalanceDetailsDialog: UserBalanceDetailsDialog as React.ComponentType<{
    trigger: React.ReactNode
    data: OrgBalanceDetailsDialogProps | UserBalanceDetailsDialogProps
  }>,
}

export const UserTopUpForm = ({
  userId,
  variant = 'full',
  onClose,
}: UserTopUpFormProps) => {
  return (
    <TopUpForm
      config={userTopUpConfig}
      userId={userId}
      variant={variant}
      onClose={onClose}
    />
  )
}
